














import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "brand-invoices-settings": () =>
      import(
        "@/components/app/admin/settings/brands/ecommerce/brandInvoiceSettings.vue"
      ),
    "brand-price_tax-settings": () =>
      import(
        "@/components/app/admin/settings/brands/ecommerce/brandTaxSettings.vue"
      ),
    "brand-tickets-settings": () =>
      import(
        "@/components/app/admin/settings/brands/tickets/brandTicketsSettings.vue"
      ),
    "brand-fraud-settings": () =>
      import("@/components/app/admin/settings/fraud/brandFraudSettings.vue"),
    "brand-affiliate_systems-settings": () =>
      import(
        "@/components/app/admin/settings/affiliates/brandAffiliatesSettings.vue"
      )
  }
})
export default class PredefinedSettings extends Vue {
  public $refs!: {
    predefinedComponent: HTMLFormElement;
  };

  // Props
  @Prop({ required: true })
  public code!: string;

  @Prop({ required: true })
  public isProcessing!: boolean;

  @Prop({ default: false })
  public dynamicSettingsLoading!: boolean;

  public predefinedCodes = [
    "affiliate_systems",
    "invoices",
    "fraud",
    "price_tax",
    "tickets"
  ];

  public created() {
    if (this.predefinedCodes.includes(this.code)) {
      return;
    }
    this.predefinedSettingsAreLoading(false);
  }

  public validate() {
    if (this.$_.has(this, "$refs.predefinedComponent.validate")) {
      return this.$refs["predefinedComponent"].validate();
    }
    return Promise.resolve();
  }

  public save() {
    if (this.$_.has(this, "$refs.predefinedComponent.save")) {
      return this.$refs["predefinedComponent"].save();
    }
    return Promise.resolve();
  }

  public revertToInitialState() {
    if (!this.$_.has(this, "$refs.predefinedComponent.revertToInitialState")) {
      return;
    }

    this.$refs["predefinedComponent"].revertToInitialState();
  }

  public get isSaveButtonDisabled() {
    return this.$_.get(
      this.$refs,
      "predefinedComponent.isSaveButtonDisabled",
      false
    );
  }

  public get isLoading() {
    return this.$_.get(this.$refs, "predefinedComponent.isLoading", false);
  }

  public predefinedSettingsAreChanged(value: boolean) {
    this.$emit("predefinedSettingsAreChanged", value);
  }

  public predefinedSettingsHasErrors(value: boolean) {
    this.$emit("predefinedSettingsHasErrors", value);
  }

  public predefinedSettingsAreLoading(value: boolean) {
    this.$emit("predefinedSettingsAreLoading", value);
  }
}
